import React from 'react';
import PropTypes from 'prop-types';

const Button = (props) => {
    const {
        size = 'full',
        color = 'primary',
        rounded = true,
        onClick,
        disabled = false
    } = props;

    let className = 'border-2 border-rose-700 p-3 text-sm flex items-center justify-center gap-2 ';

    if(size === 'full') {
        className += 'w-full border-none '
    }
    if(color === 'primary') {
        className += 'bg-black text-white '
    }
    if(rounded) {
        className += 'rounded-lg '
    }
    if(size === 'small') {
        className += 'w-max py-1.5 '
    }
    if(color === 'secondary') {
        className += 'bg-rose-700 text-white '
    }
    if(color === 'tertiary') {
        className += 'bg-none text-rose-700 '
    }
    if(disabled) {
        className += 'opacity-50 '
    }

    return (
        <button 
            className={className}
            onClick={onClick}
            disabled={disabled}
        >
            {props.children}
        </button>
    )
}

Button.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
    rounded : PropTypes.bool,
    onClick : PropTypes.func
};

export default Button;



